import { paymentMethodTitle } from '@avalara/bat-apps-shared/helpers/payment-methods';
import { newPaymentMethodWording } from '../components/shared/payment/payment-method-selector';

import type { PaymentWording } from '@avalara/types/index';
import type { State } from '@avalara/types/reducer-states';

export const selectDefaultPaymentMethod = (state: State) => {
  const {
    account: { paymentMethods },
  } = state;

  if (!paymentMethods || paymentMethods.length === 0) return null;

  return paymentMethods.find((a) => a.defaultPaymentMethod) || null;
};

export const selectPaymentMethodSelectionInfo = (state: State) => {
  const {
    account: { paymentMethods, selectedPaymentMethod },
  } = state;

  const selectedPaymentMethodId = selectedPaymentMethod?.Id || newPaymentMethodWording;

  const fieldValues = paymentMethods.map<PaymentWording>((p) => ({
    wording: paymentMethodTitle(p),
    paymentMethod: p,
  }));

  return {
    selectedPaymentMethodId,
    fieldValues,
  };
};
